import {InfoCircleRegularIcon} from 'shells/icon/svg/info-circle-regular-icon';
import {Link} from 'shells/link/link';

import {VerificationState} from './consts';
import {ForwardingAddressFlow} from './forwarding-address-flow';
import {getVerificationStatus} from './helpers';
import {SendTestEmailButton} from './send-test-email-button';
import {SetupSection} from './setup-section';

interface Props {
    emailAddress: string | undefined;
    nutshellAddress: string;
    isVerified: boolean;
    verificationState: VerificationState;
    onSendTestEmail: () => Promise<void>;
    isSending: boolean;
}

export function ForwardingSection(props: Props) {
    const verificationState = getVerificationStatus(props.isVerified, props.verificationState);

    return (
        <SetupSection
            title='Forwarding'
            verificationState={verificationState}
            description='Forward emails from your shared address to a Nutshell destination address, by setting it up in your email provider’s settings.'
            headerAction={
                <Link
                    icon={InfoCircleRegularIcon}
                    variant='primary'
                    size='small'
                    href='https://support.nutshell.com/en/articles/14464281-shared-email-inbox-in-nutshell'
                    newTab={true}
                >
                    See instructions
                </Link>
            }
        >
            <div className='pad-24 pad-8 flex flex-dir-col align-center gap-8'>
                <ForwardingAddressFlow
                    emailAddress={props.emailAddress}
                    nutshellAddress={props.nutshellAddress}
                    isVerified={props.isVerified}
                />
                <SendTestEmailButton
                    verificationState={props.verificationState}
                    onSendTestEmail={props.onSendTestEmail}
                    isSending={props.isSending}
                />
            </div>
        </SetupSection>
    );
}
